import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PremixCalculatorService {
  // BehaviorSubject to share calculator data across components
  private calculatorDataSubject = new BehaviorSubject<any[]>([]);
  public calculatorData$ = this.calculatorDataSubject.asObservable();
  private fullDataSubject = new BehaviorSubject<any[]>([]);
  public fullData$ = this.fullDataSubject.asObservable();
  private ongoingRequest$: Observable<any> | null = null;

  constructor(private http: HttpClient) { }

  getCalculatorPageData(): Observable<any> {
    const cachedData = this.fullDataSubject.value;
    if (cachedData && cachedData.length > 0) {
      return of(cachedData);
    }
    if (this.ongoingRequest$) {
      return this.ongoingRequest$;
    }
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.GET_CALCULATOR_PAGE_DATA);
    this.ongoingRequest$ = this.http.get<any>(appURL).pipe(
      tap(() => {
        this.ongoingRequest$ = null;
      }),
      shareReplay(1)
    );
    return this.ongoingRequest$;
  }
  setCalculatorData(data: any[]): void {
    this.calculatorDataSubject.next(data);
  }

  setFullData(data: any[]): void {
    this.fullDataSubject.next(data);
  }

  // Method to get current calculator data
  getCurrentCalculatorData(): any[] {
    return this.calculatorDataSubject.value;
  }

  getFullCachedData(): any[] {
    return this.fullDataSubject.value;
  }

  clearCache(): void {
    this.fullDataSubject.next([]);
    this.calculatorDataSubject.next([]);
    this.ongoingRequest$ = null;
  }

  getPremixLegalText(): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.GET_LEGAL);
    return this.http.get<any>(appURL);
  }

  //premix calculator export to pdf section
  ExportPdf(premixCalculationData: any): Observable<any> {
    let appURL: string = buildApiUrl(API_ENDPOINTS.PREMIX_CALCULATOR.EXPORT_PDF);
    return this.http.post(appURL, premixCalculationData, {
      responseType: 'blob'
    });
  }
}
